import Heading from '@src/elements/Heading';
import { CtaFragment } from '@src/graphql/gql-types';
import { COLOR_SIDECAR, COLOR_WHITE } from '@src/types/colors';
import React from 'react';
import styles from './HeroContent.module.scss';
import CTAButton from '@src/components/Button/CTAButton';
import EnquireButton from '../Header/EnquireButton';
import { FOOTER_SCROLL_TO_ID } from '@src/constants/site';

interface HeroContent {
  heading?: string;
  description?: string;
  primaryCta?: CtaFragment;
  secondaryCta?: CtaFragment;
  displayTourBookingButton?: boolean;
  isCommunity?: boolean;
}

const HeroContent: React.FC<HeroContent> = ({
  heading,
  description,
  primaryCta,
  secondaryCta,
  displayTourBookingButton,
  isCommunity
}) => {
  return (
    <div className={styles.heroContent}>
      <Heading priority={1} fontStyle="h1" className={styles.heroTitle}>
        {heading}
      </Heading>

      {description && <p className={styles.heroDescription}>{description}</p>}

      <div className={styles.buttonsContainer}>
        {/* Book a tour button */}
        {displayTourBookingButton && isCommunity && (
          <div className={styles.buttons}>
            <EnquireButton
              testid="bookATourButton"
              buttonText="Book a Tour"
              color={COLOR_SIDECAR}
              scrollToId={FOOTER_SCROLL_TO_ID}
              size="auto"
            />
          </div>
        )}

        {primaryCta && (
          <div className={styles.buttons}>
            <CTAButton
              color={COLOR_SIDECAR}
              label={primaryCta.label || ''}
              fillVariant={displayTourBookingButton ? 'outline' : 'filled'}
              cta={primaryCta}
            />
          </div>
        )}

        {secondaryCta && (
          <div className={styles.buttons}>
            <CTAButton
              color={COLOR_WHITE}
              fillVariant="outline"
              cta={secondaryCta}
              label={secondaryCta.label || ''}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroContent;
